import { useEffect } from 'react';
import { dataLayerPush } from '../../../domain/google/dataLayerPush';

type IPropsUseOfferTypeAnalytics = {
    isNewBuilding: boolean;
    hasAnyPriority: boolean;
    offerId: string;
    organizationName: string;
}

export const useOfferTypeAnalytics = ({
    isNewBuilding,
    offerId,
    hasAnyPriority,
    organizationName
}: IPropsUseOfferTypeAnalytics) => {
    useEffect(() => {
        if (! isNewBuilding) {
            dataLayerPush({ offerType: hasAnyPriority ? 'VAS' : 'NoVAS', offerId, organizationName });
        }
    }, [ isNewBuilding, offerId, hasAnyPriority, dataLayerPush ]);
};

